export const fetchData = async <T>(url: string): Promise<T> => {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Fetch Data error! status: ${response.status}, ${response.statusText}`);
        }

        return await response.json();
    } catch (err) {
        console.error('Wystąpił błąd podczas pobierania danych:', err);
        throw err;
    }
};
